import { Routes as Switch, Route } from "react-router-dom";
import Login from "../Pages/Login";
import AfterAuthRoutes from "./AfterAuthRoutes";
import VirtualOMS from "src/VirtualOMS/VirtualOMS";
import OrderBookPage from "src/Pages/Orderbook";

const Routes = () => {
  return (
    <>
      <Switch>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<AfterAuthRoutes />} />
        <Route path="/virtual_oms" element={<VirtualOMS />} />
        <Route path="/orderbook" element={<OrderBookPage />} />
      </Switch>
    </>
  );
};

export default Routes;
